import type { SortOrdering } from '../types';
import { sortOrderingSchema } from '../types';

export function assertSortParam(value: unknown): asserts value is SortOrdering {
  sortOrderingSchema.parse(value);
}
